import { HTTP } from "@/helpers/http-common"

const url = "/api/migrator"

const download = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/download`, data, { responseType: "blob", timeout: 60000000 }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default { download }



// WEBPACK FOOTER //
// ./src/services/generales/migrator/index.js